const views = {
    'aem-view@': {
        template: '<wow-aem-portal project="the-drop"></wow-aem-portal>'
    }
};

module.exports = function ($stateProvider) {
    const analyticsData = {
        isAEM: true,
        pageMetadata: [
            'PageMetadataService', function () {
                return null;
            }
        ],
        fullPageRefreshOnForceReload: true
    };
    $stateProvider
        .state('shop.thedrop', {
            url: '/the-drop',
            data: analyticsData,
            views
        })
        .state('shop.thedrop.page', {
            url: '{path:any}', // avoid '/' being encoded
            data: analyticsData
        })
        ;
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/thedrop.js
 **/